import { useCallback, useRef, useState } from 'react';

interface Props {
  onFile: (file: File) => void | Promise<void>;
  disabled?: boolean;
  /** Extensiones permitidas (con punto). Default: planillas de padrones. */
  allowed?: string[];
  /** Texto de ayuda bajo el dropzone. */
  hint?: string;
}

const ALLOWED_PLANILLAS = ['.xlsx', '.xls', '.xlsm', '.csv', '.txt'];

export function UploadDropzone({ onFile, disabled, allowed, hint }: Props) {
  const [drag, setDrag] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const exts = allowed ?? ALLOWED_PLANILLAS;

  const handleFiles = useCallback(
    (files: FileList | null) => {
      if (!files || files.length === 0) return;
      const file = files[0];
      const ext = '.' + (file.name.split('.').pop()?.toLowerCase() ?? '');
      if (!exts.includes(ext)) {
        alert(`Extensión no permitida. Usar: ${exts.join(', ')}`);
        return;
      }
      onFile(file);
    },
    [onFile, exts],
  );

  return (
    <div
      className={`dropzone ${drag ? 'dropzone--drag' : ''} ${disabled ? 'dropzone--disabled' : ''}`}
      onDragOver={(e) => {
        e.preventDefault();
        if (!disabled) setDrag(true);
      }}
      onDragLeave={() => setDrag(false)}
      onDrop={(e) => {
        e.preventDefault();
        setDrag(false);
        if (!disabled) handleFiles(e.dataTransfer.files);
      }}
      onClick={() => !disabled && inputRef.current?.click()}
      role="button"
      tabIndex={0}
    >
      <input
        ref={inputRef}
        type="file"
        accept={exts.join(',')}
        style={{ display: 'none' }}
        onChange={(e) => handleFiles(e.target.files)}
      />
      <div className="dropzone__icon">⬆</div>
      <p className="dropzone__title">
        {disabled ? 'Procesando…' : 'Arrastrá un archivo aquí o hacé clic'}
      </p>
      {/* El hint sale de la misma lista que valida, así no vuelve a decir
          ".xlsx · .csv" mientras se aceptan .xls, .xlsm y .txt. */}
      <p className="dropzone__hint">
        {hint ?? `Formatos soportados: ${exts.join(' · ')} · máx 200 MB`}
      </p>
    </div>
  );
}
